<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="6" md="5" sm="6" cols="12">
          <v-card
            class="deposit-form"
            :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
          >
            <v-row>
              <v-col
                v-if="!walletInternalTransferDetails?.otpsent"
                cols="12"
                sm="12"
                md="12"
              >
                <fieldset>
                  <legend>Mam Transfer From</legend>
                  <v-select
                    ref="fromAccountSelected"
                    solo
                    :items="fromFormattedAccounts"
                    item-value="id"
                    item-text="displayText"
                    append-icon="mdi-chevron-down"
                    label="Select From Account"
                    class="custom-select"
                    hide-details="auto"
                    @change="fromAccountSelected"
                  ></v-select>
                </fieldset>
                <span v-if="error.fromAccountError" class="error-message">
                  {{ error.fromAccountError }}
                </span>
              </v-col>
              <v-col
                v-if="!walletInternalTransferDetails?.otpsent"
                cols="12"
                sm="12"
                md="12"
              >
                <fieldset>
                  <legend>Mam Transfer To</legend>
                  <v-select
                    ref="toAccountSelected"
                    solo
                    :items="toFormattedAccounts"
                    item-value="id"
                    item-text="displayText"
                    append-icon="mdi-chevron-down"
                    label="Select From Account"
                    class="custom-select"
                    hide-details="auto"
                    @change="toAccountSelected"
                  ></v-select>
                </fieldset>
                <span v-if="error.toAccountError" class="error-message">
                  {{ error.toAccountError }}
                </span>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="12"
                v-if="!walletInternalTransferDetails?.otpsent"
              >
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field
                    min="1"
                    v-model="amount"
                    label="$"
                    type="number"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
                <span v-if="error.amount_error" class="error-message">
                  {{ error.amount_error }}
                </span>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="12"
                v-if="
                  this.currency.name !== 'USD' &&
                  !walletInternalTransferDetails?.otpsent
                "
              >
                <fieldset>
                  <legend>
                    Amount in
                    <span :style="{ color: currency.color }"
                      >({{ currency.name }})</span
                    >
                  </legend>
                  <v-text-field
                    readonly
                    v-model="currencyAmount"
                    :label="currency.symbol"
                    type="number"
                    single-line
                    solo
                    hide-details
                    class="custom-select text-muted"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col
                v-if="walletInternalTransferDetails?.otpsent"
                cols="12"
                sm="12"
                md="12"
              >
                <fieldset>
                  <legend>Enter OTP Code</legend>
                  <v-text-field
                    type="number"
                    v-model="verifiedCode"
                    @input="limitDigits"
                    @keydown="onKeyDown"
                    label="Verify Code"
                    single-line
                    solo
                    hide-details="auto"
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
                <span v-if="error.code_error" class="error-message">
                  {{ error.code_error }}
                </span>
              </v-col>

              <v-col
                v-if="walletInternalTransferDetails?.otpsent"
                cols="12"
                sm="12"
                md="12"
              >
                <v-btn
                  @click.prevent="submitForm"
                  :loading="loading2"
                  :disabled="loading2"
                  tile
                  elevation="0"
                  class="ma-0 text-capitalize btn-account d-block w-100"
                  color="greenMain"
                >
                  Submit
                </v-btn>
              </v-col>
              <v-col
                v-if="!walletInternalTransferDetails?.otpsent"
                cols="12"
                sm="12"
                md="12"
              >
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  @click.prevent="handleForm"
                  tile
                  elevation="0"
                  class="ma-0 text-capitalize btn-account d-block w-100"
                  color="greenMain"
                >
                  Send
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import {
  MAM__WALLET__ACTIONS,
  TRANSACTION__ACTIONS,
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      loading2: false,
      fromDialog: false,
      toDialog: false,
      verifiedCode: null,
      fromClient_trading_account_id: null,
      toClient_trading_account_id: null,
      fromAccount: null,
      toAccount: null,
      amount: null,
      currencyAmount: "",
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color: "#fff",
      },
      error: {
        fromAccountError: null,
        toAccountError: null,
        amount_error: null,
        code_error: null,
      },
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
    };
  },

  computed: {
    ...mapState("transactions", ["internalTransfer"]),
    ...mapState("mamWallet", [
      "mam_wallet_summary",
      "mamwalletinternaltransferAccount",
      "walletInternalTransfer",
      "walletInternalTransferDetails",
    ]),

    fromFormattedAccounts() {
      const wallet = this.mam_wallet_summary?.mamWalletHistory;

      if (wallet) {
        return [
          {
            id: "manager", // or use a more unique identifier
            displayText: `Manager Wallet Balance: ${wallet.manager_available_balance}`,
          },
          {
            id: "investor",
            displayText: `Investor Wallet Balance: ${wallet.investor_available_balance}`,
          },
        ];
      }
      return [];
    },

    toFormattedAccounts() {
      if (
        this.mamwalletinternaltransferAccount &&
        Array.isArray(this.mamwalletinternaltransferAccount)
      ) {
        return this.mamwalletinternaltransferAccount.map((account) => {
          const {
            id,
            trading_account_no,
            account_type_display,
            Balance,
            currency_name,
          } = account;
          const displayText = `${trading_account_no} (${account_type_display}) ${Balance} ${currency_name}`;
          return { id, displayText };
        });
      }
      return [];
    },

    seriesData() {
      if (!this.toAccount) return [];

      const balance = Number(this.toAccount?.Balance) || 0;
      const equity = Number(this.toAccount?.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },

    seriesforFromAccount() {
      if (!this.fromAccount) return [];

      const balance = Number(this.fromAccount?.Balance) || 0;
      const equity = Number(this.fromAccount?.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },
  },

  watch: {
    amount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    },
  },

  methods: {
    ...mapActions("transactions", [TRANSACTION__ACTIONS.PAYMENTMETHOD]),
    ...mapActions("mamWallet", [
      MAM__WALLET__ACTIONS.MAMWALLETINTERNALTRANSFERACCOUNT,
      MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY,
      MAM__WALLET__ACTIONS.WALLETINTERNALTRANSFERCODE,
      MAM__WALLET__ACTIONS.CONFIRMWALLETINTERNALTRANSFER,
    ]),

    limitDigits() {
      if (this.verifiedCode.length > 6) {
        this.verifiedCode = this.verifiedCode.slice(0, 6);
      }
    },

    onKeyDown(event) {
      if (event.target.value.length >= 6 && event.keyCode !== 8) {
        event.preventDefault();
      }
    },

    fromAccountSelected(selectedId) {
      const wallet = this.mam_wallet_summary?.mamWalletHistory;

      if (selectedId === "manager") {
        this.fromAccount = {
          id: 1,
          Balance: wallet.manager_available_balance,
          currency_name: "USD",
        };
      } else if (selectedId === "investor") {
        this.fromAccount = {
          id: 2,
          Balance: wallet.investor_available_balance,
          currency_name: "USD",
        };
      }

      this.fromClient_trading_account_id = selectedId; // still useful if you compare later
    },

    toAccountSelected(selectedAccount) {
      const filter = this.mamwalletinternaltransferAccount.find(
        (item) => item.id === selectedAccount
      );
      this.toClient_trading_account_id = selectedAccount;
      this.toAccount = filter;
      if (filter) {
        this.currency.rate = filter.currency_rate;
        this.currency.name = filter.currency_name;
        this.currency.symbol = filter.currency_symbol;
        this.currency.color = filter.symbol_color;
      }
    },
    async handleForm() {
      this.loading = true;
      try {
        // ✅ Validate From Wallet
        if (!this.fromAccount || !this.fromAccount.id) {
          this.error.fromAccountError =
            "Select from wallet (manager or investor)";
          return;
        } else {
          this.error.fromAccountError = null;
        }

        // ✅ Validate To Account
        if (!this.toAccount) {
          this.error.toAccountError = "Select to account";
          return;
        } else {
          this.error.toAccountError = null;
        }

        // ✅ Currency check
        // if (this.toAccount.currency_name !== this.fromAccount.currency_name) {
        //   this.error.toAccountError = "Currency mismatch";
        //   this.error.fromAccountError = "Currency mismatch";
        //   return;
        // } else {
        //   this.error.toAccountError = null;
        //   this.error.fromAccountError = null;
        // }

        const amountValue = Number(this.amount);
        const availableBalance = Number(this.fromAccount?.Balance || 0);

        // ✅ Amount validation
        if (!this.amount || isNaN(amountValue)) {
          this.error.amount_error = "Please enter a valid amount";
          return;
        }

        if (amountValue <= 0) {
          this.error.amount_error = "Amount must be greater than 0";
          return;
        }

        // ✅ Wallet balance check
        if (amountValue > availableBalance) {
          this.error.amount_error = `Insufficient balance. Your selected wallet balance is (${availableBalance}$)`;
          return;
        }

        this.error.amount_error = null;

        // ✅ Prepare data
        const data = {
          fromAccountID: this.fromAccount?.id,
          toAccountID: this.toAccount?.id,
          amount: amountValue,
          client_account_id: this.toAccount.client_account_id,
          trading_account_no: this.toAccount.trading_account_no,
        };

        // ✅ Submit
        await this[MAM__WALLET__ACTIONS.WALLETINTERNALTRANSFERCODE](data);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.loading2 = true;
      try {
        if (!Object.values(this.error).some((err) => err !== null)) {
          await this[MAM__WALLET__ACTIONS.CONFIRMWALLETINTERNALTRANSFER]({
            code: this.verifiedCode,
          });
          this.verifiedCode = null;
          this.fromAccount = null;
          this.toAccount = null;
          this.amount = null;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading2 = false;
      }
    },
  },
  async mounted() {
    await this[MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY]();
    await this[MAM__WALLET__ACTIONS.MAMWALLETINTERNALTRANSFERACCOUNT]();
    await this[TRANSACTION__ACTIONS.PAYMENTMETHOD]();
  },
};
</script>

<style scoped>
.error-message {
  color: #ff567f;
  font-size: 13px;
}
</style>
